<template>
  <main
    :class="['aui-content', { 'aui-content--tabs': $route.meta.isTab }]"
    class="content"
    id="main-content"
  >
    <Header />
    <div class="content_body">
      <home v-if="$route.name === 'main'"></home>
      <template v-if="keyRouteList.includes($route.name)">
        <router-view :key="$router.currentRoute.fullPath" />
      </template>
      <template v-else>
        <router-view />
      </template>
    </div>
    <Footer
      v-if="!$route.meta.hideFooter"
    />
  </main>
</template>

<script>
import { isURL } from "@/utils/validate";
import Home from "../modules/home/index.vue";
import Footer from "./footer.vue";
import Header from "./header.vue";
export default {
  data() {
    return {
      keyRouteList: ["Scene"], // 增加router的key值，路由上query发生改变时也能重新创建组件生命周期
    };
  },
  components: {
    Home,
    Footer,
    Header,
  },
  methods: {
    // tabs, 是否通过iframe展示
    tabIsIframe(url) {
      return isURL(url);
    },
    // tabs, 选中tab
    tabSelectedHandle(tab) {
      tab = this.$store.state.contentTabs.filter(
        (item) => item.name === tab.name
      )[0];
      if (tab) {
        this.$router.push({
          name: tab.name,
          // 'params': { ...tab.params },
          // 'query': { ...tab.query }
        });
      }
    },
    // tabs, 删除tab
    tabRemoveHandle(tabName) {
      if (tabName === "home") {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      );
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName =
          this.$store.state.contentTabsActiveName = "home";
        return false;
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        let tab =
          this.$store.state.contentTabs[
            this.$store.state.contentTabs.length - 1
          ];
        this.$router.push({
          name: tab.name,
          params: { ...tab.params },
          query: { ...tab.query },
        });
      }
    },
    // tabs, 关闭其它
    tabsCloseOtherHandle() {
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => {
          return (
            item.name === "home" ||
            item.name === this.$store.state.contentTabsActiveName
          );
        }
      );
    },
    // tabs, 关闭全部
    tabsCloseAllHandle() {
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name === "home"
      );
      this.$router.push({ name: "home" });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  background: #fff;
  // padding-right: 56px;
  padding-top: 0 !important;
  min-height: 100vh;
}
.content_body{
  min-height: calc(100vh - 585px);
}
</style>
